module.exports = __webpack_public_path__ + "static/media/makeinindia.ec38973a.png";